"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummyLogger = void 0;
var DummyLogger = /** @class */ (function () {
    function DummyLogger() {
        this.tag = '';
        this.description = '';
    }
    DummyLogger.prototype.matchesTag = function () {
        return false;
    };
    DummyLogger.prototype.setLevel = function () { };
    DummyLogger.prototype.enable = function () { };
    DummyLogger.prototype.disable = function () { };
    DummyLogger.prototype.log = function () { };
    DummyLogger.prototype.debug = function () { };
    DummyLogger.prototype.info = function () { };
    DummyLogger.prototype.warn = function () { };
    DummyLogger.prototype.error = function () { };
    return DummyLogger;
}());
exports.DummyLogger = DummyLogger;
//# sourceMappingURL=dummy_logger.js.map